// extracted by mini-css-extract-plugin
module.exports = {"steps":"_35173b0","tear":"_ea161f8","inner":"_ec3472e","step":"_1343134","left":"_c47ca6a","right":"_abe0e49","title":"_8858140","text":"_580aeed"};